// extracted by mini-css-extract-plugin
module.exports = {"container":"Meal_container__f9la6","name":"Meal_name__3LK81","description":"Meal_description__1cpir","price":"Meal_price__3hF7H"};